<template>

    <div class="goodsInfodetail">
        <div class="container">
            <div class="product_detail-main">
                <div class="product_detail-main-img">
                  <vue-magnify :previewImg="currentImg" :zoomImg="currentImg"></vue-magnify>
                  <div class="tl-tabs">
                    <div class="prev" @click="scrollPrev" :class="{disabled:prevDisabled}">
                      <i class="icon iconfont iconprev">
                        <img src="~@/assets/image/tabprev.png">
                      </i>
                    </div>
                    <div class="next" @click="scrollNext" :class="{disabled:nextDisabled}">
                      <i class="icon iconfont iconnext">
                        <img src="~@/assets/image/tabnext.png">
                      </i>
                    </div>
                    <div class="img-list-box">
                      <ul class="img-tabs" :style="{width:ulWidth,left:ulLeft+'px'}">
                        <li v-for="(img,index) in productImgList" :key="index" @click="changeShowImg(img)">
                          <img v-lazy="img" alt :key="img">
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="tr product_detail-main-info">

                    <div class="tr-title">{{ goodsInfo.name }}</div>

                    <div class="tr-price tr-group">

                        <div class="tr-right">
                            <span class="now-price">
                                <i>￥</i>
                                <span class="price-num">{{ goodsInfo.price }}</span>
                            </span>
                            <span class="old-price">
                                <del>￥{{ goodsInfo.mktprice }}</del>
                            </span>
                        </div>
                    </div>

                    <div class="tr-group underline" v-if="product.promotion_list && product.promotion_list.length > 0">
                        <div class="tr-title-left">促销</div>
                        <div class="tr-right">
                            <span class="cx-item" v-for="(item, index) in product.promotion_list"
                                :key="index">{{ item.name }}</span>
                        </div>
                    </div>

                    <!-- <div class="tr-group">
              <div class="tr-title-left">重量</div>
              <div class="tr-right">
                <span class="weight">1.65Kg</span>
              </div>
            </div>-->
                  <div class="product_detail_txt" v-if="product.default_spes_desc">
                    <template v-if="product.default_spes_desc">
                        <div class="tr-group" v-for="(value, key, i) in product.default_spes_desc" :key="i">
                            <div class="tr-title-left">{{ key }}</div>
                            <div class="tr-right">
                                <div class="color" v-for="(item, index) in value" :key="index"
                                    :class="{ 'active': item.is_default }" @click="changeSpes(item.product_id)">
                                    <a href="javascript:;">{{ item.name }}</a>
                                </div>
                            </div>
                        </div>
                    </template>
                  </div>

                  <div class="product_detail_num">
                    <div class="tr-group">
                        <div class="tr-title-left">数量</div>
                        <div class="tr-right">
                            <el-input-number v-model="buyNum" @change="handleChange" :min="1" label="购买数量" size="small"
                                :max="buyMax"></el-input-number>
                            <div class="kc">库存{{ product.stock }}件</div>
                        </div>
                    </div>
                  </div>


                  <a v-if="goodsInfo.uploadcanvas" target="_blank" :href="goodsInfo.uploadcanvas">
                  <div class="downloadcanve">
                    下载画布模板
                  </div>
                  </a>

                    <div class="tr-foot">
                        <div class="btn add-btn" v-if="goodsInfo.marketable == 1" @click="addToCart"
                            v-show="goodsInfo.is_nomal_virtual != 2">加入购物车</div>
                        <div class="btn buy-btn" v-if="goodsInfo.marketable == 1" @click="buyNow">立刻购买</div>

                        <div class="btn sold-out" v-if="goodsInfo.marketable == 2">已下架</div>

<!--                        <div class="collete-btn" @click="changeFav" v-if="goodsInfo.marketable == 1"-->
<!--                            :title="isFav ? '取消收藏' : '添加收藏'">-->
<!--                            <i class="icon iconfont iconshoucang" v-if="isFav"></i>-->
<!--                            <svg class="icon" width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" v-if="isFav">-->
<!--                                <path-->
<!--                                    d="M23.9986 5L17.8856 17.4776L4 19.4911L14.0589 29.3251L11.6544 43L23.9986 36.4192L36.3454 43L33.9586 29.3251L44 19.4911L30.1913 17.4776L23.9986 5Z"-->
<!--                                    fill="#FF7159" stroke="#FF7159" stroke-width="3" stroke-linejoin="round" />-->
<!--                            </svg>-->
<!--                            <svg class="icon" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>-->
<!--                                <path-->
<!--                                    d="M23.9986 5L17.8856 17.4776L4 19.4911L14.0589 29.3251L11.6544 43L23.9986 36.4192L36.3454 43L33.9586 29.3251L44 19.4911L30.1913 17.4776L23.9986 5Z"-->
<!--                                    fill="none" stroke="#FF7159" stroke-width="3" stroke-linejoin="round" />-->
<!--                            </svg>-->
<!--                            <div>{{ isFav ? '已收藏' : '收藏' }}</div>-->
<!--                        </div>-->
                    </div>
                  <div v-if="goodsInfo.brief" class="product_detail_num" style="padding-top: 10px">
                    <div class="tr-group" v-if="goodsInfo.brief">

                      <div class="tr-title-left">提示</div>
                      <div class="tr-right">
                        <div style="white-space: pre-line;line-height: 2;" v-html="goodsInfo.brief"></div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>


            <div class="product_detail-sub">
<div class="left">
  <div class="title" v-if="saleRanking">
    热门产品
  </div>
  <div class="item" v-for="(item,index) in saleRanking" :key="index" @click="toDetails(item.id)">
    <!-- <div class="number">{{index+1}}</div> -->
    <div class="img"><img :src="item.image" alt=""></div>
    <div class="info">
      <div class="name">{{item.name}}</div>

    </div>
  </div>

</div>
              <div class="right">


<div class="tab-ul flex">
  <div v-if="goodsInfo.intro" class="tab" @click="scrollTo('specification')"><div :class="{ active: activeTab === 'specification' }" class="botton">规格</div></div>
  <div v-if="goodsInfo.intro1" class="tab" @click="scrollTo('description')"><div :class="{ active: activeTab === 'description' }" class="botton">细节描述</div></div>
  <div v-if="goodsInfo.intro2" class="tab" @click="scrollTo('advantage')"><div :class="{ active: activeTab === 'advantage' }" class="botton">产品优势</div></div>
  <div v-if="goodsInfo.intro3" class="tab" @click="scrollTo('booth')"><div :class="{ active: activeTab === 'booth' }" class="botton">详情介绍</div></div>
</div>



<div class="product_context">


  <div  v-if="goodsInfo.intro" class="editor"  id="specification">
    <div class="tip">规格</div>
    <div   v-html="goodsInfo.intro">
    </div>
  </div>


  <div  class="editor" id="description">
    <div v-if="goodsInfo.intro1" class="tip">细节描述</div>
    <div   v-html="goodsInfo.intro1">
    </div>
  </div>

  <div  v-if="goodsInfo.intro2" class="editor" id="advantage">
    <div class="tip">产品优势</div>
    <div   v-html="goodsInfo.intro2">
    </div>
  </div>

  <div  v-if="goodsInfo.intro3" class="editor"  id="booth">
    <div class="tip">详情介绍</div>
    <div   v-html="goodsInfo.intro3">
    </div>
  </div>
  </div>


</div>
                <!-- <div>价格：{{ goodsInfo.price }} </div> -->

                <!-- {{ goodsInfo }} -->

            </div>

          <div class="product_detail-case" v-if="caseList.length>0">

              <div class="tip">案例展示</div>
              <div class="editor">
                <div class="case-item flex">
                  <div class="case_item_one" v-for="(good) in caseList" :key="good.id">
                    <router-link :to="{name:'casedetail',params: {goodsId:good.id}}">
                      <div class="product_item_img">
                        <div class="product_item_img_cell">
                          <img v-bind:src="good.cover" />
                          <div class="casetitle">{{good.type_name}}</div>
                        </div>

                      </div>

                    </router-link>
                  </div>
                  <div class="case_item_one_none"></div>
                  <div class="case_item_one_none"></div>
                  <div class="case_item_one_none"></div>
                </div>
              </div>

          </div>

            <div style="height: 100px; width: 100%;"></div>

        </div>
    </div>
    </div>
</template>
<script>
import vueMagnify from '@/components/vue-magnify/index.vue'
export default {
    name: 'ProductDetail',
    components: { vueMagnify },
    props: {},
    data() {
        return {
          activeTab: null,
            toTopShow: false,
            buyNum: 1,
            tabTitleArr: [{
                id: 'detail',
                name: '商品详情',
            },
            {
                id: 'comment',
                name: '评论晒单',
            },
            ],
            tabIndex: 0,
            goodsId: '',
            imgList: [],
            caseList:[],
            ulLeft: 0,
            isEnd: false,
            goodsInfo: {}, //商品详情
            product: {}, // 规格详情
            isFav: false, //收藏
            goodsParams: null, //商品参数信息
            goodsComments: {
                count: 0,
                page: 1,
                limit: 15,
                list: null,
            }, // 商品评论信息, //商品评论信息
            currentImg: '', //列表选中图片
            selectCommentImg: '', //评论选中图片
            selectCommentImgIndex: null, //评论选中图片
            selectCommentIndex: null, //评论选中图片
            loadingShow: false,
            saleRanking: [], //销量排行榜
            price: "0",
        };
    },
    computed: {
        // zfy add
        mainImage: function () {
            let res = '';
            if (this.goodsInfo.album && this.goodsInfo.album.length > 0) {
                res = this.goodsInfo.album[0];
            }
            return res;
        },
        subImage: function () {
            let res = [];
            if (this.goodsInfo.album && this.goodsInfo.album.length > 1) {
                res = this.goodsInfo.album.slice(1);
            }
            return res;
        },



        // copy from old version
        ulWidth() {
            if (this.goodsInfo.album) {
                return this.goodsInfo.album.length * 100 + 'px'
            }
            return 0 + 'px'
        },
        prevDisabled() {
            return this.ulLeft == 0
        },
        nextDisabled() {
          console.log(this.goodsInfo.album,this.isEnd);
            if (this.goodsInfo.album) {
                return this.goodsInfo.album.length <= 4 || this.isEnd
            }
            return false
        },
        buyMax() {
            return this.product.stock
        },
        productImgList() {
            return this.goodsInfo.album
        },
        
    },
    watch: {
        $route(to) {
            if (to.name == 'detail') {
                let goodsId = this.$route.params.goodsId
                if (goodsId) {
                    this.goodsId = goodsId
                    this.getAllInfo()
                }
            }
            if (this.$route) {
                this.buyNum = 1
            }
        },
    },
    methods: {
      scrollTo(id) {
        this.activeTab = id; // 设置当前激活的 tab
        console.log("this.activeTab",this.activeTab);
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      },
        //切换商品规格
        changeSpes(id) {
            this.$api.getProductInfo({ id }).then(res => {
                if (res.status) {
                    this.product = res.data
                    this.goodsInfo.price = this.product.price
                }
            })
        },
        goodsBrowsing() {
            let data = {
                goods_id: this.goodsInfo.id,
            }
            this.$api.addGoodsBrowsing(data).then()
        },
        buyNow() {
            let data = {
                product_id: this.product.id,
                nums: this.buyNum,
                type: 2, // 区分加入购物车和购买
            }
            this.$api.addCart(data).then(res => {
                if (res.status) {
                    let cartIds = res.data
                    this.$router.push({
                        name: 'order',
                        query: {
                            cart_ids: JSON.stringify(cartIds)
                        },
                    })
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                    })
                }
            })
        },
        getAllInfo() {
            this.getGoodsDetail();
            this.getGoodsParams();

            //this.getGoodsComments()
        },
        // 获取销量排行榜
        getSalesRanking() {
            this.$api.getSalesRanking({}).then(res => {
                if (res.status) {
                    this.saleRanking = res.data
                    console.log(this.saleRanking)
                }
            })
        },
        //商品详情
        getGoodsDetail() {
            let data = {
                id: this.goodsId,
            }
            let userToken = this.$storage.get('userToken')
            if (userToken) {
                data['token'] = userToken
            }
            let that = this;
            this.loadingShow = true
            this.$api.goodsDetail(data).then(res => {
                if (res.status == true) {
                    this.loadingShow = false
                    console.log("goodsDetail", res);
                    let info = res.data
                    this.goodsInfo = info
                    this.product = res.data.product
                    this.isFav = info.isfav === 'true' ? true : false
                    this.currentImg = this.goodsInfo.album[0]
                    if (this.$storage.get('userToken')) {
                        this.goodsBrowsing()
                    }
                   this.caseList=info.case_list;
                    // that.$nextTick(
                    //     function () {
                    //         let galleryTop = new Swiper('.lcontainer', {
                    //             slidesPerGroup: 1,
                    //             slidesPerView: 1,
                    //             spaceBetween: 10,
                    //             nextButton: '.thumd .swiper-button-next',
                    //             prevButton: '.thumd .swiper-button-prev',
                    //             observer: true, //修改swiper自己或子元素时，自动初始swiper
                    //             observeParents: true, //修改swiper的父元素时,自动初始swiper
                    //
                    //         });
                    //         let galleryThumbs = new Swiper('.thumd', {
                    //             spaceBetween: 10,
                    //             slidesPerView: 3,
                    //             touchRatio: 0.2,
                    //             slideToClickedSlide: true,
                    //             centeredSlides: true,
                    //             slidesPerGroup: 1,
                    //             grabCursor: true,
                    //             slidesOffsetBefore: 66,
                    //             slidesOffsetAfter: 66,
                    //             observer: true,
                    //
                    //         });
                    //         galleryTop.params.control = galleryThumbs;
                    //         galleryThumbs.params.control = galleryTop;
                    //
                    //
                    //     })
                }
            })
        },
        //获取商品参数
        getGoodsParams() {
            let data = {
                id: this.goodsId
            }
            this.$api.goodsParams(data).then(res => {
                if (res.status) {
                    this.goodsParams = res.data
                }
            })
        },


        // copy from old version
        // ...mapActions(['getCartNumsAction']),
        handleChange(value) { },
        scrollPrev() {
            this.ulLeft = 0
        },
        scrollNext() {
            let num = this.productImgList.length - 4
            let left = 54 * num + 24
            this.ulLeft = -left
            this.isEnd = true
          console.log(123)
        },
        addToCart() {
            let data = {
                product_id: this.product.id,
                nums: this.buyNum,
            }
            this.$api.addCart(data).then(res => {
                if (res.status) {
                    this.getCartNums()
                    this.$router.push({
                        path: '/buySuccess',
                        query: { goodsName: this.goodsInfo.name },
                    })
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                    })
                }
            })
        },
        // buyNow() {
        //     let data = {
        //         product_id: this.product.id,
        //         nums: this.buyNum,
        //         type: 2, // 区分加入购物车和购买
        //     }
        //     this.$api.addCart(data).then(res => {
        //         if (res.status) {
        //             let cartIds = res.data
        //             this.$router.push({
        //                 name: 'order',
        //                 query: { cart_ids: JSON.stringify(cartIds) },
        //             })
        //         } else {
        //             this.$message({
        //                 message: res.msg,
        //                 type: 'error',
        //             })
        //         }
        //     })
        // },
        // 获取购物车数量
        getCartNums() {
            this.$api.getCartNum().then(res => {
                if (res.status) {
                    this.getCartNumsAction(res.data)
                }
            })
        },
        //切换评论图片大图
        changeBigImg(img, i, index, item) {
            if (img == item['currentImg']) {
                this.$set(item, 'showBigImg', false)
                this.$set(item, 'currentImg', '')
            } else {
                this.$set(item, 'showBigImg', true)
                this.$set(item, 'currentImg', img)
            }
            // if (this.selectCommentIndex == index) {
            // } else {
            //   this.selectCommentImg = img;
            //   this.selectCommentImgIndex = i;
            // }

            this.selectCommentIndex = index
        },
        //切换显示图片
        changeShowImg(img) {
            this.currentImg = img
        },
        returnTo(id) {
            // document.getElementById(id).scrollIntoView({behavior: "smooth"})
            document.getElementById(id).scrollIntoView()
        },
        //获取商品参数
        // getGoodsParams() {
        //     let data = { id: this.goodsId }
        //     this.$api.goodsParams(data).then(res => {
        //         if (res.status) {
        //             this.goodsParams = res.data
        //         }
        //     })
        // },
        // getGoodsComments() {
        //     let data = {
        //         page: this.goodsComments.page,
        //         limit: this.goodsComments.limit,
        //         goods_id: this.goodsId,
        //     }
        //     this.$api.goodsComment(data).then(res => {
        //         if (res.status) {
        //             let _list = res.data.list
        //             _list.forEach(item => {
        //                 item.ctime = timeToDate(item.ctime)
        //                 this.$set(item, 'showBigImg', false)
        //                 this.$set(item, 'currentImg', '')
        //             })
        //             this.goodsComments.list = _list
        //             this.goodsComments.count = res.data.count
        //         }
        //     })
        // },
        //商品详情
        // getGoodsDetail() {
        //     let data = {
        //         id: this.goodsId,
        //     }
        //     let userToken = this.$storage.get('userToken')
        //     if (userToken) {
        //         data['token'] = userToken
        //     }
        //     this.loadingShow = true
        //     this.$api.goodsDetail(data).then(res => {
        //         if (res.status == true) {
        //             this.loadingShow = false
        //             let info = res.data
        //             this.goodsInfo = info
        //             this.product = res.data.product
        //             this.isFav = info.isfav === 'true' ? true : false
        //             this.currentImg = this.goodsInfo.album[0]
        //             if (this.$storage.get('userToken')) {
        //                 this.goodsBrowsing()
        //             }
        //         }
        //     })
        // },
        // goodsBrowsing() {
        //     let data = {
        //         goods_id: this.goodsInfo.id,
        //     }
        //     this.$api.addGoodsBrowsing(data).then()
        // },
        // //切换商品规格
        // changeSpes(id) {
        //     this.$api.getProductInfo({ id }).then(res => {
        //         if (res.status) {
        //             this.product = res.data
        //         }
        //     })
        // },
        //切换收藏
        changeFav() {
            let data = {
                goods_id: this.goodsInfo.id,
            }
            this.$api.goodsCollection(data).then(res => {
                if (res.status) {
                    this.isFav = !this.isFav
                }
            })
        },
        // getAllInfo() {
        //     this.getGoodsDetail()
        //     this.getGoodsParams()
        //     this.getGoodsComments()
        // },
        handleScroll() {
            this.scrollTop = this.scrollTop =
                window.pageYOffset || document.body.scrollTop
            if (this.scrollTop > 500) {
                this.toTopShow = true
            } else {
                this.toTopShow = false
            }
        },
        scrollToTop() {
            document.body.scrollTop = document.documentElement.scrollTop = 0
        },
        // 获取销量排行榜
        // getSalesRanking() {
        //     this.$api.getSalesRanking({}).then(res => {
        //         if (res.status) {
        //             this.saleRanking = res.data
        //             console.log(this.saleRanking)
        //         }
        //     })
        // },
        toDetails(id) {
            this.$router.push({
                name: 'detail',
                params: { goodsId: id },
            })
        },

    },
    created() {
        // console.log("11111111111");
        if (this.$route.name == 'detail') {
            let goodsId = this.$route.params.goodsId
            if (goodsId) {
                this.goodsId = goodsId
                this.getAllInfo()
            }
        }
        if (this.$route) {
            this.buyNum = 1
        }
    },
    updated() {

    },
    mounted() {
        // 获取销量排行榜

      // 获取销量排行榜
      this.getSalesRanking()

    }
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "@/assets/css/product_detail.scss";
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
@import "@/assets/css/productdetail.scss";
</style>


